// @flow
import React, { Component } from 'react';
import { StyleSheet, View } from 'react-native';
import { kebabCase } from 'lodash';
import config from '../../../config';

const styles = StyleSheet.create({
  imgContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    alignSelf: 'center',
  },
});

class DownloadAppButtons extends Component<void, void> {
  GOOGLE_PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${config.APP_IDENTIFIER}`;

  APPLE_APP_STORE_URL =
    config.APP_STORE_ID &&
    `https://itunes.apple.com/app/${kebabCase(config.PRODUCT_BUNDLE_DISPLAY_NAME)}/id${config.APP_STORE_ID}`;

  render() {
    return (
      <View style={styles.imgContainer}>
        <a href={this.GOOGLE_PLAY_STORE_URL}>
          <img alt="Get it on Google Play" src="assets/img/google-play-badge.png" height="45" />
        </a>
        {this.APPLE_APP_STORE_URL && (
          <a href={this.APPLE_APP_STORE_URL}>
            <img alt="Download on the App Store" src="assets/img/apple-app-store-badge.svg" height="45" />
          </a>
        )}
      </View>
    );
  }
}

export default DownloadAppButtons;
